namespace GeniuzPOS.AdvPromo {
    export namespace PsAdvPromoItem4ExemptService {
        export const baseUrl = 'AdvPromo/PsAdvPromoItem4Exempt';

        export declare function Create(request: Serenity.SaveRequest<PsAdvPromoItem4ExemptRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Update(request: Serenity.SaveRequest<PsAdvPromoItem4ExemptRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Delete(request: Serenity.DeleteRequest, onSuccess?: (response: Serenity.DeleteResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Retrieve(request: Serenity.RetrieveRequest, onSuccess?: (response: Serenity.RetrieveResponse<PsAdvPromoItem4ExemptRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function List(request: Serenity.ListRequest, onSuccess?: (response: Serenity.ListResponse<PsAdvPromoItem4ExemptRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            Create = "AdvPromo/PsAdvPromoItem4Exempt/Create",
            Update = "AdvPromo/PsAdvPromoItem4Exempt/Update",
            Delete = "AdvPromo/PsAdvPromoItem4Exempt/Delete",
            Retrieve = "AdvPromo/PsAdvPromoItem4Exempt/Retrieve",
            List = "AdvPromo/PsAdvPromoItem4Exempt/List"
        }

        [
            'Create', 
            'Update', 
            'Delete', 
            'Retrieve', 
            'List'
        ].forEach(x => {
            (<any>PsAdvPromoItem4ExemptService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
